const MARKETS_ENABLED = ['en-ca', 'fr-ca'];

export const showGlobalErrorPage = ({
  locale,
}) => MARKETS_ENABLED.includes(locale?.toLowerCase());
